/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * MobiViz
 * The MobiViz API description (multi-version)
 * OpenAPI spec version: 1.0.0
 */
import { fetchApi } from "../../../fetch";
import type {
  StatsControllerGetMetricRangesV0200,
  TimeIntervalsDto,
  VehicleTypesDto,
} from "../../models";

export const getStatsControllerGetMetricRangesV0Url = () => {
  return `/api/v0/stats/metric-ranges`;
};

export const statsControllerGetMetricRangesV0 = async (
  options?: RequestInit,
): Promise<StatsControllerGetMetricRangesV0200> => {
  return fetchApi<StatsControllerGetMetricRangesV0200>(
    getStatsControllerGetMetricRangesV0Url(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getStatsControllerGetVehicleTypesV0Url = () => {
  return `/api/v0/stats/vehicle-types`;
};

export const statsControllerGetVehicleTypesV0 = async (
  options?: RequestInit,
): Promise<VehicleTypesDto> => {
  return fetchApi<VehicleTypesDto>(getStatsControllerGetVehicleTypesV0Url(), {
    ...options,
    method: "GET",
  });
};

export const getStatsControllerGetTimeIntervalsV0Url = () => {
  return `/api/v0/stats/time-intervals`;
};

export const statsControllerGetTimeIntervalsV0 = async (
  options?: RequestInit,
): Promise<TimeIntervalsDto> => {
  return fetchApi<TimeIntervalsDto>(getStatsControllerGetTimeIntervalsV0Url(), {
    ...options,
    method: "GET",
  });
};
